import { IconMcp, rem } from '@bitrise/bitkit-v2';
import { Box } from '@chakra-ui/react/box';
import { keyframes } from '@emotion/react';

const drift = keyframes`
  0%, 100% { transform: translate(45%, 40%); }
  15% { transform: translate(30%, 10%); }
  30% { transform: translate(35%, -25%); }
  50% { transform: translate(-5%, 40%); }
  70% { transform: translate(10%, 30%); }
  85% { transform: translate(-45%, 0%); }
`;

const McpTourVisual = () => (
  <Box
    alignItems="center"
    aspectRatio="41 / 23"
    background="color/indigo/subtle"
    borderRadius="4"
    display="flex"
    justifyContent="center"
    overflow="hidden"
    position="relative"
    _before={{
      animation: `${drift} 8s ease-in-out infinite`,
      background: 'color/turquoise/minimal',
      content: '""',
      height: '130%',
      insetBlockStart: '-15%',
      insetInlineStart: '15%',
      maskImage: 'radial-gradient(closest-side, #000, transparent)',
      position: 'absolute',
      width: '70%',
    }}
    _motionReduce={{ _before: { animation: 'none' } }}
  >
    <IconMcp boxSize={rem(112)} color="icon/primary" position="relative" />
  </Box>
);

export default McpTourVisual;
